export default __webpack_public_path__ + "static/media/cucharon.c80a7560.png";